module.exports = __webpack_public_path__ + "media/images/flags/64/GoSquared-7b663a77dc17b22a32314a7c7fb21a24.png";